/// <amd-module name="Wit/MentionsAutocomplete/Providers/ArtifactsCache" />
import { Deferred } from "./Utils";

export class ArtifactsCache<TArtifact> {
    private _cache: { [key: number]: Promise<TArtifact> } = {};
    private _queue: { key: number; deferred: Deferred<TArtifact> }[] = [];
    private _keyPoppedFromQueue: { [key: number]: boolean } = {};

    constructor(
        private _artifactsLoader:
            | ((keys: number[]) => { [key: number]: Promise<TArtifact> })
            | ((keys: number[]) => { [key: number]: Promise<TArtifact> }),
        private _queueWaitMSec: number,
        private _maxBatchSize: number
    ) {}

    public getArtifactPromise(key: number): Promise<TArtifact> {
        if (this._cache[key] !== undefined) {
            return this._cache[key];
        }

        var deferred = new Deferred<TArtifact>();
        const promise = deferred.promise;
        this._cache[key] = promise;
        this._queue.push({
            key: key,
            deferred: deferred
        });
        this._keyPoppedFromQueue[key] = false;
        this._delayProcessQueue(key);

        return promise;
    }

    protected _delayProcessQueue(triggeringKey: number) {
        setTimeout(() => this._processQueue(triggeringKey), this._queueWaitMSec);
    }

    protected _processQueue(triggeringKey: number) {
        if (this._keyPoppedFromQueue[<any>triggeringKey]) {
            return;
        }
        while (this._queue.length > 0) {
            let batch: { key: number; deferred: Deferred<TArtifact> }[];
            const maxBatchSize = this._maxBatchSize;
            if (this._queue.length <= maxBatchSize) {
                batch = this._queue;
                this._queue = [];
            } else {
                batch = this._queue.slice(0, maxBatchSize);
                this._queue = this._queue.slice(maxBatchSize);
            }
            for (let i = 0; i < batch.length; i++) {
                this._keyPoppedFromQueue[batch[i].key] = true;
            }
            this._processBatch(batch);
        }
    }

    protected _processBatch(batch: { key: number; deferred: Deferred<TArtifact> }[]) {
        const keys = batch.map(batchItem => batchItem.key);
        var artifacts = this._artifactsLoader(keys);
        batch.forEach(batchItem => {
            if (artifacts.hasOwnProperty(batchItem.key)) {
                const artifactPromise = artifacts[batchItem.key];
                artifactPromise.then(
                    artifact => {
                        batchItem.deferred.resolve(artifact);
                    },
                    function() {
                        batchItem.deferred.reject.apply(batchItem.deferred, Array.from(arguments));
                    }
                );
            } else {
                batchItem.deferred.reject(new Error("Artifact was missing from results of batch load."));
            }
        });
    }
}
